import styled from 'styled-components'

export const FieldWrapper = styled.div`
  margin-top: 20px;
`
